// extracted by mini-css-extract-plugin
export var compactFilters = "_cp-4";
export var detailImage = "_cp-1";
export var dropdownContainer = "_cp-2";
export var imageContainer = "_cp-0";
export var selectedCard = "_cp-3";